import React, { ReactNode, useContext } from 'react';
import NextLink, { LinkProps } from 'next/link';

import { GlobalContext } from '~/contexts/global';
import {
  NEXT_PDP_EXPERIMENT_NAME,
  NEXT_CART_EXPERIMENT_NAME,
  isPDP,
  PDP_REGEX,
  isIndexablePage,
  IS_INDEXABLE_PAGE_REGEX,
} from '~/lib/util/constants';

const URL_WHITELIST_EXACT: Array<string> = ['/'];
const URL_WHITELIST_PREFIX: Array<string> = [
  '/browse',
  '/search',
  '/software',
  '/creative-resources',
  '/templates',
  '/courses-learning',
  '/collections',
  '/asksumo/',
  '/courses-more',
  '/checkout/',
];
const URL_WHITELIST_CONTAINS: Array<string> = ['#reviews'];

export function Link({
  children,
  href,
  target = '_self',
  ...props
}: {
  children?: ReactNode;
  href: string;
  target?: '_self' | '_blank';
} & (React.HTMLAttributes<HTMLAnchorElement> | LinkProps)) {
  const whitelistPrefix: Array<string> = [...URL_WHITELIST_PREFIX];
  const whitelistExact: Array<string> = [...URL_WHITELIST_EXACT];
  const whitelistRegex: Array<RegExp> = [];
  const whitelistContains: Array<string> = [...URL_WHITELIST_CONTAINS];

  const { experimentVariants } = useContext(GlobalContext);
  const isNextPDPEnabled =
    experimentVariants?.[NEXT_PDP_EXPERIMENT_NAME] === 'enabled';
  const isNextCartEnabled =
    experimentVariants?.[NEXT_CART_EXPERIMENT_NAME] === 'enabled';

  if (!href) {
    return <></>;
  }

  if (isNextPDPEnabled && isPDP(href)) {
    whitelistRegex.push(PDP_REGEX);
  }

  if (isNextCartEnabled && href.startsWith('/cart')) {
    whitelistPrefix.push('/cart/');
  }

  if (isIndexablePage(href)) {
    whitelistRegex.push(IS_INDEXABLE_PAGE_REGEX);
  }

  // if link is whitelisted use next/link to render the a tag
  if (
    (target === '_self' &&
      (whitelistExact.some((url) => href === url) ||
        whitelistPrefix.some((url) => href.startsWith(url)) ||
        whitelistRegex.some((regex) => regex.test(href)))) ||
    whitelistContains.some((url) => href.includes(url))
  ) {
    return (
      <NextLink href={href} {...props}>
        {children}
      </NextLink>
    );
  }

  return (
    <a href={href} target={target} {...props}>
      {children}
    </a>
  );
}
